export const SAMPLE_CAMPAIGN_BODY_HTML = `Hello :token{key="guestName" label="First name"} :token{key="guestLastName" label="Last name"},

We hope you enjoyed your recent stay with us on :token{key="checkoutDate" label="Checkout date"}. We would love to welcome you back soon.

Book directly through our website and enjoy **15% off** your next visit, plus **free late checkout** on select dates.`

export const SAMPLE_CAMPAIGN_RICHTEXT_FIELDS = {
  bodyHtml: SAMPLE_CAMPAIGN_BODY_HTML,
  col1Html: '',
  col2Html: '',
  col3Html: '',
  personalHtml: '',
  finePrintHtml: ''
}

export default SAMPLE_CAMPAIGN_BODY_HTML
